// extracted by mini-css-extract-plugin
module.exports = {"PriceRow":"PriceRow_PriceRow__2L5DK","label":"PriceRow_label__diHPp","value":"PriceRow_value__321cE","input":"PriceRow_input__1FmeB","conclusion":"PriceRow_conclusion__298MU"};